import { Component,OnInit  } from '@angular/core';
import { Beneficiaire } from './models/beneficiaire';
import { BeneficiaireService } from './services/beneficiaire.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'client-dashbord-tipay';
  users: Beneficiaire[] = [];

  constructor(private beneficiaireService: BeneficiaireService) {}

  ngOnInit(): void {

  }

}
